import React from "react";

const Logo = () => (
  <div className="flex justify-center mb-6">
    <img src={require("../assets/faviconr.png")} alt="Logo" className="h-16 w-auto" />
  </div>
);

export default Logo;
